import { LoadingManager } from "@core/managers/loading.manager";
import { NotificationsManager } from "@core/managers/notifications.manager";
import { ETAB_ROUTES, META_MOBILE_NAVIGATION_TABS } from "@etab/config";
import { META_HTML_TITLE } from "@core/constants";
import { ACTION_PROFILE_INIT } from "@etab/stores/types";
import { useProfileStore } from "@etab/stores/profile";

import UserMenuRoot from "./UserMenu.root.vue";
import UserMenuPage from "./UserMenu.page.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.userMenu.root.path,
      name: ETAB_ROUTES.userMenu.root.name,
      redirect: { name: ETAB_ROUTES.userMenu.main.name },
      meta: { [META_HTML_TITLE]: "ETAB.PAGES.ACCOUNT.@TITLE", [META_MOBILE_NAVIGATION_TABS]: true },
      component: UserMenuRoot,
      children: [
        {
          path: ETAB_ROUTES.userMenu.main.path,
          name: ETAB_ROUTES.userMenu.main.name,
          component: UserMenuPage,
          async beforeEnter(to, from, next) {
            const profileStore = useProfileStore();
            LoadingManager.show();
            try {
              await profileStore[ACTION_PROFILE_INIT]();
            } catch (error) {
              NotificationsManager.error({ message: "ERRORS.@SOMETHING_WENT_WRONG" });
            } finally {
              LoadingManager.hide();
              // whatever happens, let's go to profile
              next();
            }
          },
        },
      ],
    },
  ];
}
